import { ICalculatorMcfValues } from '../../types/features';
import {
  ISaveLeadV1Request,
  EBenefitProgram,
  EObjectType,
  ERealEstateType,
  EEmploymentType,
  EIncomeConfirmation,
} from '../../repositories/mortgage-broker-calculator/entities/save_lead_v1/SaveLeadV1Request';
import { IAttachMortgageToLeadV1Request } from '../../repositories/mortgage-broker-calculator/entities/attach_mortgage_to_lead_v1/AttachMortgageToLeadV1Request';
import { ILead } from '../../components/RefinLeadBanner/types';

export const mapCalculatorValuesToSaveLeadRequest = (
  calculatorValues: ICalculatorMcfValues,
  phone: string,
): ISaveLeadV1Request => {
  return {
    regionId: Number(calculatorValues.region),
    objectCost: calculatorValues.objectCost,
    downPayment: calculatorValues.downPayment,
    loanTermYears: calculatorValues.loanTerm,
    benefitProgram: calculatorValues.benefitProgram as unknown as EBenefitProgram,
    objectType: calculatorValues.objectType as unknown as EObjectType,
    realEstateType: calculatorValues.realEstateType as unknown as ERealEstateType,
    employmentType: calculatorValues.typeOfEmployment as unknown as EEmploymentType,
    incomeConfirmation: calculatorValues.incomeConfirm as unknown as EIncomeConfirmation,
    payrollBankId: calculatorValues.payrollBank ? Number(calculatorValues.payrollBank) : null,
    phone,
  };
};

export const mapLeadToAttachMortgageRequest = (lead: ILead, leadId: string): IAttachMortgageToLeadV1Request => {
  return {
    id: leadId,
    rate: lead.mortgageRate || null,
    debt: lead.mortgageAmountRemaining || null,
    hasMortgage: lead.hasMortgage,
  };
};
